<div class="content-height overflow-hidden overflow-lg-auto">

    <aerp-base-schema-form *ngIf="data?.model && layout" [dataProcessor]="dataProcessor.bind(this)"
        [model]="data?.model" [layout]="layout" [dataModel]="dataModel" (onSubmitResponse)="onSubmitResponse($event)">
    </aerp-base-schema-form>
</div>

<ng-template #openCongratulationPopup>
    <div class="p-3">
        <div class="d-flex justify-content-between align-items-center flex-column">
            <img class="img img-fluid"
                src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1699869058836Done%20Icon%20Green%201.png"
                alt="">
            <h1 class="fst-italic">Congratulations</h1>
            <p class="fs-5 text-center">Your loan application is in progress and sent to the banks.</p>
            <button (click)="checkStatus()" class="btn btn-primary-dark-custom px-7 text-light">Check Status</button>
        </div>
    </div>
</ng-template>

<ng-template #openUploadPopup let-modal>
    <div class="modal-header">
        <div>
            <h5 class="fw-bold text-dark">{{headingList[data?.model?.documentName]?.heading}}</h5>
            <p class="text-muted">{{headingList[data?.model?.documentName]?.subHeading}}</p>
        </div>

        <button type="button" class="btn-close text-dark mt-n7" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>

    </div>
    <div class="modal-body mx-2">
        <div *ngIf="!data?.model?.file && !uploadedDocs.includes(data?.model?.documentName)">
            <div class="h-50">
                <div class="bg-custom-gray d-flex justify-content-center flex-column align-items-center">
                    <p>This is a sample document and may vary *</p>
                    <img [src]="sampleImageUrl" class="img" alt="sampleImage" width="160" height="160">
                </div>
            </div>
            <p class="text-gray w-75 mx-auto mt-2 mb-3 text-center">
                Document format - jpg, jpeg, png, PDF Document Size < 5MB </p>
        </div>
        <div *ngIf="data?.model && !data?.model?.file && uploadedDocs.includes(data?.model?.documentName)">
            <div class="bg-primary-light py-2 my-3 d-flex justify-content-center rounded-custom text-indigo fw-bold">
                <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715666714105document-text-indigo.png"
                    alt="icon" class="img img-fluid me-3">
                <span class="text-indigo fw-bold fs-5 mt-0">
                    {{getFileNameFromS3Path(data?.model?.fileData[data?.model?.documentName]?.filePath[0])}}</span>
            </div>
            <p class="text-gray w-75 mx-auto mt-2 mb-3 text-center">
                Document format - jpg, jpeg, png, PDF Document Size < 5MB </p>
        </div>
    </div>


    <aerp-base-schema-form *ngIf="data?.model && mobileDocLayout" [dataProcessor]="dataProcessor.bind(this)"
        [model]="data?.model" [layout]="mobileDocLayout" [dataModel]="dataModel"
        (onSubmitResponse)="onSubmitResponse($event)">
    </aerp-base-schema-form>

    <!-- <div class="my-1 d-flex justify-content-center">
        Need help? <p class="text-primary ms-1">Connect to Loan Expert</p>
    </div> -->
</ng-template>